var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"thematic",rawName:"v-thematic"}],class:{
    'item': true,
    'item-active': _vm.value == _vm.raw
    },on:{"click":_vm.onSelect}},[_c('span',[_vm._t("default")],2),_c('div',{directives:[{name:"thematic",rawName:"v-thematic"}],class:{
      'circle-action': true,
      'active': _vm.value == _vm.raw
  }})])}
var staticRenderFns = []

export { render, staticRenderFns }